// extracted by mini-css-extract-plugin
export var actionButton = "_fz-t";
export var buttonContainer = "_fz-0";
export var buttonContainer2 = "_fz-1";
export var buttonSection = "_fz-2";
export var details = "_fz-3";
export var dropdownItem = "_fz-5";
export var dropdownItemsContainer = "_fz-4";
export var fileInput = "_fz-r";
export var headerButton = "_fz-6";
export var icon = "_fz-7";
export var input = "_fz-8";
export var macroListItem = "_fz-9";
export var mainContent = "_fz-a";
export var microText = "_fz-b";
export var modal = "_fz-w";
export var optionsButton = "_fz-c";
export var paperclip = "_fz-s";
export var pillContent = "_fz-d";
export var preview = "_fz-e";
export var preview2 = "_fz-f";
export var quillEditor = "_fz-q";
export var selectedMacro = "_fz-g";
export var sidebar = "_fz-h";
export var sidebarHeader = "_fz-j";
export var sidebarList = "_fz-i";
export var sidebarListItem = "_fz-k";
export var sidebarSearch = "_fz-l";
export var snoozeDurationWrapper = "_fz-v";
export var statusPillContainer = "_fz-m";
export var tagsContainer = "_fz-n";
export var unselectedMacro = "_fz-o";
export var variable = "_fz-u";
export var wrapper = "_fz-p";